import React, { FunctionComponent, useMemo } from "react";
import { Trans } from "@lingui/macro";
import { useFormikContext } from "formik";
import { EnteredTaxCodeRow } from "./EnteredTaxCodeRow";

export interface Props {
  taxCodesOrderedByEntry: Set<string>;
}

export const EnteredTaxCodesTable: FunctionComponent<Props> = ({ taxCodesOrderedByEntry }) => {
  const { values } = useFormikContext<object>();

  const orderedKeys = useMemo(() => {
    const keys = Array.from(taxCodesOrderedByEntry).filter((key) => values.hasOwnProperty(key));

    Object.keys(values).forEach((key) => {
      if (keys.indexOf(key) > -1) return;
      keys.push(key);
    });
    return keys;
  }, [values, taxCodesOrderedByEntry]);

  return useMemo(() => {
    return (
      <div id="codesok">
        <div className="codesrow" id="rijhoofd">
          <div className="colcode">
            <h2>
              <Trans>Code</Trans>
            </h2>
          </div>
          <div className="colamount">
            <h2>
              <Trans>Bedrag</Trans>
            </h2>
          </div>
          <div className="coldescr">
            <h2>
              <Trans>Omschrijving</Trans>
            </h2>
          </div>
        </div>
        {orderedKeys.map((key) => (
          <EnteredTaxCodeRow key={key} name={key} />
        ))}
      </div>
    );
  }, [orderedKeys]);
};

EnteredTaxCodesTable.displayName = "EnteredTaxCodesTable";
